import { render, staticRenderFns } from "./OrderAnalysis.vue?vue&type=template&id=0820e454&scoped=true&"
import script from "./OrderAnalysis.vue?vue&type=script&lang=js&"
export * from "./OrderAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./OrderAnalysis.vue?vue&type=style&index=0&id=0820e454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0820e454",
  null
  
)

export default component.exports